// extracted by mini-css-extract-plugin
export default {"container":"aBOid1ev5J0fnInl1WOX"};